<template>
	<AtomForm
		:action="formSpreeEndpoint"
		:is-submitting="isFormSubmitting"
		:is-success="isFormSent"
		:is-error="isFormFailed"
		@submit="submit"
	>
		<input
			type="hidden"
			name="subject"
		>
		<div class="flex flex-col md:flex-row gap-6 md:gap-12">
			<AtomInputText
				v-model="firstName"
				class="basis-1/2"
				title="Voornaam"
				name="firstName"
				is-required
			/>
			<AtomInputText
				v-model="lastName"
				class="basis-1/2"
				title="Achternaam"
				name="lastName"
				is-required
			/>
		</div>
		<AtomInputEmail
			v-model="email"
			title="E-mailadres"
			name="email"
			is-required
		/>
		<AtomInputTextArea
			v-model="message"
			title="Bericht"
			name="message"
			is-required
		/>
	</AtomForm>
</template>

<script lang="ts" setup>
import formspreeFormSubmit from '#base/helpers/formspreeFormSubmit';

const {
	formSpreeEndpoint,
} = defineProps<{ formSpreeEndpoint: string }>();

const email = ref('');
const firstName = ref('');
const lastName = ref('');
const message = ref('');

const isFormSent = ref(false);
const isFormFailed = ref(false);
const isFormSubmitting = ref(false);

watch([firstName, lastName, email, message], () => {
	if (!isFormSubmitting.value) {
		isFormSent.value = false;
		isFormFailed.value = false;
		isFormSubmitting.value = false;
	}
});

const route = useRoute();

function submit(e: FormDataEvent) {
	e.preventDefault();

	isFormSubmitting.value = true;

	formspreeFormSubmit(formSpreeEndpoint, {
		subject: `Contactformulier ingevuld door ${firstName.value} ${lastName.value}`,
		firstName: firstName.value,
		lastName: lastName.value,
		email: email.value,
		message: message.value,
		page: route.fullPath,
	})
		.then(() => {
			firstName.value = '';
			lastName.value = '';
			email.value = '';
			message.value = '';

			isFormSent.value = true;
			isFormFailed.value = false;
		})
		.catch(() => {
			isFormSent.value = false;
			isFormFailed.value = true;
		})
		.finally(() => {
			isFormSubmitting.value = false;
		});
}
</script>
